import { withAdminAuth } from "../../../components/GetAuth";
import PageHeader from "../../../components/PageHeader";
import { CurrencyFormatter } from "../../../components/Helpers";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportToolbar from "../components/ReportToolbar";
import ReportTable from "../components/ReportTable";
import { toFixed2, toNumber } from "../components/exportUtils";

const unpaidAmount = (row) => toNumber(row?.total_amount) - toNumber(row?.total_paid_amount);

const columns = [
    { key: "driver_id", label: "Driver Id" },
    { key: "name", label: "Name", primary: true },
    { key: "total_assigned", label: "Total Assigned", align: "right" },
    { key: "total_confirmed", label: "Confirmed Pickup", align: "right" },
    { key: "total_failed", label: "Failed Pickup", align: "right" },
    { key: "total_unpaid", label: "Total Unpaid", align: "right" },
    { key: "total_paid", label: "Total Paid", align: "right" },
    { key: "unpaid_amount", label: "Unpaid Amount", align: "right", render: (row) => CurrencyFormatter(unpaidAmount(row)), exportValue: (row) => unpaidAmount(row).toFixed(2) },
    { key: "total_paid_amount", label: "Paid Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.total_paid_amount)), exportValue: (row) => toFixed2(row?.total_paid_amount) },
    { key: "total_discount_amount", label: "Discount Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.total_discount_amount)), exportValue: (row) => toFixed2(row?.total_discount_amount) },
    { key: "total_amount", label: "Total Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.total_amount)), exportValue: (row) => toFixed2(row?.total_amount) },
];

const DriverReports = () => {
    const { websiteData } = useWebsite();
    useSiteBranding("Driver Reports", websiteData);

    const report = useServerReport("report/driver-report");

    return (<div className={`${styles.MainDiv}`}>
        <PageHeader title="Driver Reports" trail={[{ label: "Reports" }]} />

        <div className={`${styles.MainCard}`}>
            <ReportToolbar report={report} columns={columns} title="Driver Report" filename="driver-report" searchPlaceholder="Search by driver id or name" />
            <ReportTable report={report} columns={columns} minWidth={1100} />
        </div>
    </div>);
};

export default withAdminAuth(DriverReports);
